/* Shop-rail carousel: 3 visible, controls only when more exist.
   No framework, no external calls. */
(function () {
  "use strict";
  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    var shop = document.querySelector(".guide-article .ga-shop");
    if (!shop) return;
    var rail = shop.querySelector(".ga-rail");
    if (!rail) return;
    var cells = rail.querySelectorAll(".ga-rail__cell");
    if (cells.length <= 3) return; /* 3 or fewer: static grid, no controls */
    rail.classList.add("ga-rail--carousel");
    var head = shop.querySelector(".ga-shop__head");
    if (!head) return;
    var nav = document.createElement("div");
    nav.className = "ga-shop__nav";
    function makeBtn(dir, label) {
      var b = document.createElement("button");
      b.type = "button";
      b.className = "ga-shop__navbtn";
      b.setAttribute("aria-label", label);
      b.innerHTML = '<svg viewBox="0 0 16 16" width="16" height="16" aria-hidden="true" focusable="false"><path fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" d="' + (dir < 0 ? "M10 3L5 8l5 5" : "M6 3l5 5-5 5") + '"/></svg>';
      b.addEventListener("click", function () {
        var cell = rail.querySelector(".ga-rail__cell");
        /* step = cell + the rail's real gap, read from computed style so the
           two can never desync */
        var gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
        var step = cell ? cell.getBoundingClientRect().width + gap : rail.clientWidth / 3;
        rail.scrollBy({ left: dir * step, behavior: "smooth" });
      });
      return b;
    }
    var prev = makeBtn(-1, "Previous products");
    var next = makeBtn(1, "Next products");
    nav.appendChild(prev);
    nav.appendChild(next);
    head.appendChild(nav);
    function sync() {
      var max = rail.scrollWidth - rail.clientWidth - 1;
      prev.disabled = rail.scrollLeft <= 0;
      next.disabled = rail.scrollLeft >= max;
    }
    rail.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync, { passive: true });
    /* re-sync when lazy images/DOM changes resize the rail or its cells —
       cells are observed too because a scrollWidth-only change does not
       resize the rail's own box */
    if (typeof ResizeObserver === "function") {
      var ro = new ResizeObserver(sync);
      ro.observe(rail);
      cells.forEach(function (c) { ro.observe(c); });
    }
    sync();
  });
})();
